// @mui
import { createTheme } from '@mui/material/styles'
import { grey, lightGreen, blue, red } from '@mui/material/colors'
//

const theme = createTheme({
  palette: {
    // mode: 'dark',
    //primary: blue, // Purple and green play nicely together.
    primary: {
      light: '#6286f8',
      main: '#1b5ac4',
      dark: '#003293',
      contrastText: '#ffffff',
    },
    // secondary: {
    //   ...green,
    //   A400: '#00e677',
    // },
    secondary: {
      main: '#fee90c',
      light: '#ffff59',
      dark: '#c7b700',
      contrastText: '#000000',
    },
    error: red,
    background: {
      footer: grey['50'],
      flash: lightGreen['500'],
      viewer: grey['50'],
    },
    border: {
      footer: blue['500'],
    },
  },
  typography: {
    fontFamily: [
      'Noto Sans JP',
      'sans-serif',
    ].join(','),
  },
})

export default theme
